module.exports = __webpack_public_path__ + "img/hotelscom.0afc2515.png";